import { extendTheme } from "@mui/joy/styles";

export const theme = extendTheme({
  colorSchemes: {
    light: {
      palette: {
        text: {
          primary: "#131622",
          secondary: "#3d4556",
          tertiary: "#626b7e",
        },
        primary: {
          50: "#EDF3F7",
          100: "#DBE7EF",
          200: "#B8D0E0",
          300: "#95B9D0",
          400: "#669BBC",
          500: "#3E6F8E",
          600: "#2F536A",
          700: "#1F3847",
          800: "#101C23",
          solidBg: "#0052A3",
          solidHoverBg: "#003d7a",
          solidActiveBg: "#002b57",
          outlinedBorder: "#3E6F8E",
          outlinedColor: "#1F3847",
          outlinedActiveBg: "#EDF3F7",
          softColor: "#101C23",
          softBg: "#DBE7EF",
          softActiveBg: "#B8D0E0",
          plainColor: "#1F3847",
          plainActiveBg: "#EDF3F7",
        },
        neutral: {
          50: "#f8f6f3",
          100: "#eeecea",
          200: "#dddbd8",
          300: "#c4c2c0",
          400: "#9a9ea8",
          500: "#676d7d",
          600: "#4d5363",
          700: "#343b4d",
          800: "#1c2234",
          900: "#0e1220",
        },
        danger: {
          50: "#fff0f0",
          100: "#ffd6d6",
          200: "#ffadad",
          300: "#ff8585",
          400: "#ff5c5c",
          500: "#c41c1c",
          600: "#a31616",
          700: "#7a1111",
          800: "#520b0b",
        },
        warning: {
          50: "#FFF4E5",
          100: "#FFE8CC",
          200: "#FFD199",
          300: "#FFBA66",
          400: "#FFA333",
          500: "#FF8C00",
          600: "#E67E00",
          700: "#CC7000",
          800: "#B36200",
          900: "#994F00",
        },
        common: {
          white: "#fefefe",
          black: "#080c14",
        },
        background: {
          body: "#f8f6f3",
          surface: "#fefefe",
          level1: "#eeecea",
          level2: "#dddbd8",
        },
      },
    },
  },
  fontFamily: {
    body: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif',
    display: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif',
  },
});
